<template>
  <div class="sildebar">
    <div class="sildebar_logo">
      <img :src="system.site_logo">
    </div>
    <el-scrollbar class="sildebar_scroll" :class="{isCollapse:isCollapse}">
      <sidebar-item v-for="(item,index) in sidebar" :key="index" :item="item" />
    </el-scrollbar>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import SidebarItem from './SidebarItem'
  import sidebarLayoutFn from './sidebar-layout.js';
  let sidebarLayout = [];
  export default {
    components: {
      SidebarItem
    },
    data() {
      return {
        isCollapse: true,
        sidebar: [],
        thHid: ['/deliverymap', '/address', '/address2']
      };
    },
    computed: {
      ...mapState(['system']),
      thHiddenPage() {
        return this.$projectType == 2 ? this.thHid : []
      }
    },
    mounted() {
      this.getPlatPrivilege()
      this.getRouterList()
      this.$bus.$on('getUserPrivilege', this.getRouterList)
    },
    methods: {
      ...mapActions('tagsView', ['setState']),
      ...mapMutations(['SET_STATE']),
      ...mapActions(['getPlatPrivilege', 'getUserPrivilege']),
      /**
       * 初始化sidebarLayout
       * 将分类下的所有路径放入paths中 在initRoutes中方便判断请求的路径是否在改分类下 防止过多嵌套循环
       * */
      initSidebarLayout() {
        sidebarLayout = sidebarLayoutFn(this.$projectType);
        sidebarLayout.forEach(item => {
          item.paths = [];
          item.num = 0;
          item.children.map(itm => {
            item.paths = item.paths.concat(itm.paths)
          })
        })
      },
      // 动态获取导航
      getRouterList() {
        this.initSidebarLayout()
        this.getUserPrivilege().then(data => {
          this.initRoutes(data.backend);
        })
      },

      // 初始化导航 归类
      initRoutes(list) {
        list.map(route => {
          if (route.path && route.is_show == 1) {
            sidebarLayout.map(item => {
              item.name = this.$ts(item.name);
              if (item.paths.indexOf(route.path) > -1) {
                item.children.map(itm => {
                  itm.title = this.$ts(itm.title);
                  let index = itm.paths.indexOf(route.path);
                  if (index > -1 && !itm.children[index] && !this.thHiddenPage.includes(route.path)) {
                    item.num++;
                    itm.children[index] = {
                      path: route.path,
                      name: this.$ts(route.name)
                    }
                  }
                })
              }
            })
          }
        })
        this.sidebar = sidebarLayout;
        this.setState({
          routes: sidebarLayout
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sildebar {
    height: 100vh;
    display: flex;
    flex-direction: column;

    &_logo {
      flex-shrink: 0;
      width: 66px;
      height: 66px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--theme-color);

      img {
        display: block;
        width: 40px;
        object-fit: contain;
      }
    }

    &_scroll {
      flex: 1 0 0;
      width: 200px;
      background-color: #2a3641;
      user-select: none;
    }

    &_scroll.isCollapse {
      width: 66px;
    }
  }
</style>
<style scoped>
  .sildebar_scroll>>>.el-scrollbar__wrap {
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Sidebar/index.vue